import React from 'react';
import './text-style.scss';

export interface IPageTitel {
  text: any;
}

export const PageTitel = ({ text }: IPageTitel) => {
  return <div className={'page-titel'} >{text}</div>;
};
